/**
 * Reads one count out of the insights response.
 *
 * The response lists a `count` per processing status, category and failure
 * type: `{ total, processingStatus: [{ id, name, count }], category: [...],
 * failureType: [{ name, count }] }`. A stat names the list and the item it wants
 * (`["category", 3]`, `["failureType", "Foreign Exchange"]`).
 *
 * Returns `undefined` when the item is missing, or the list is not an array, so
 * the strip shows a dash instead of a 0 that looks like a real count, and an
 * unexpected payload cannot throw.
 */
export function getInsightCount(insights, [list, match]) {
  const items = insights?.[list];
  // `Number(null)` and `Number("")` are 0, which would match a real id 0.
  if (!Array.isArray(items) || match == null || match === "") return undefined;
  const item = items.find((candidate) =>
    list === "failureType" ? candidate?.name === match : Number(candidate?.id) === Number(match),
  );
  return item?.count;
}

/**
 * The insights the strip should show for an RTK Query result.
 *
 * `data` keeps the last successful answer even when the request for the current
 * filters has failed, and that answer belongs to the previous filters. So after
 * an error only `currentData` is used: the answer for the current filters, which
 * is kept if just a refetch of the same filters failed and is missing if the
 * request for new filters failed — then the strip shows dashes, not wrong counts.
 * While the first answer is loading there is nothing to show.
 */
export function pickOverviewInsights({ isLoading, isError, data, currentData }) {
  if (isLoading) return undefined;
  return isError ? currentData : data;
}
